import { Component, inject, input } from '@angular/core';
import { FormGroupDirective, FormControl, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MobilBytteSelectors } from '@app/sales/modules/mobilephone/states/mobilbytte/mobilbytte.selectors';
import { IceAlertComponent } from '@app/shared/components/molecules/ice-alert/ice-alert.component';
import { IceCheckboxComponent } from '@app/shared/components/molecules/ice-checkbox/ice-checkbox.component';
import { IconNames } from '@app/shared/enums/icon-names';
import { select } from '@ngxs/store';

@Component({
  selector: 'app-terms-step',
  imports: [IceCheckboxComponent, ReactiveFormsModule, IceAlertComponent],
  templateUrl: './terms-step.component.html',
  styleUrl: './terms-step.component.scss',
})
export class TermsStepComponent {
  private formGroupDirective = inject(FormGroupDirective);
  data = inject<{
    equipmentUpgradeAgreementId: number;
  }>(MAT_DIALOG_DATA);

  IconNames = IconNames;

  isPhoneDamaged = input.required<boolean>();

  existingEquipmentUpgradeAgreements = select(MobilBytteSelectors.existingEquipmentUpgradeAgreements);

  get hasCustomerAcceptedTerms(): FormControl {
    return this.formGroupDirective.form?.controls?.hasCustomerAcceptedTerms as FormControl;
  }

  get hasInsurance(): boolean {
    const equipmentUpgradeAgreementId = this.data?.equipmentUpgradeAgreementId;
    if (!equipmentUpgradeAgreementId) {
      return false;
    }

    return !!this.existingEquipmentUpgradeAgreements().find(
      agreement => +agreement?.agreementId === equipmentUpgradeAgreementId
    )?.insuranceServiceId;
  }
}
